import React from "react";
import { AbsoluteFill } from "remotion";
import { TeenageEngineeringBot } from "./components/AntiSlopHardwareMascots";
import {
  Sparkles,
  Terminal,
  Coffee,
  Code2,
  HelpCircle,
  MousePointer2,
} from "lucide-react";

export const OPZuraPoseCatalog: React.FC = () => {
  return (
    <AbsoluteFill
      style={{
        backgroundColor: "#EFECE6", // Tactile warm industrial gray
        color: "#1C1917",
        fontFamily: "'Inter', sans-serif",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "100px 50px 80px",
        boxSizing: "border-box",
      }}
    >
      {/* Background Micro Grid */}
      <div
        style={{
          position: "absolute",
          inset: 0,
          backgroundImage:
            "linear-gradient(rgba(28, 25, 23, 0.05) 1px, transparent 1px), linear-gradient(90deg, rgba(28, 25, 23, 0.05) 1px, transparent 1px)",
          backgroundSize: "24px 24px",
          pointerEvents: "none",
        }}
      />

      {/* Header Pill & Title */}
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 10,
          zIndex: 10,
        }}
      >
        <div
          style={{
            backgroundColor: "#FFFFFF",
            border: "2.5px solid #1C1917",
            borderRadius: 999,
            padding: "8px 26px",
            boxShadow: "4px 4px 0px #1C1917",
            display: "inline-flex",
            alignItems: "center",
            gap: 10,
          }}
        >
          <span
            style={{
              fontFamily: "'Space Grotesk', monospace",
              fontWeight: 900,
              color: "#2563EB",
              fontSize: 20,
            }}
          >
            &#123;Z&#125;
          </span>
          <span
            style={{
              fontFamily: "'Rajdhani', sans-serif",
              fontSize: 20,
              fontWeight: 800,
              letterSpacing: 2,
              color: "#1C1917",
              textTransform: "uppercase",
            }}
          >
            OP-ZURA · OFFICIAL MASCOT RIGGING SHEET
          </span>
        </div>

        <h1
          style={{
            fontFamily: "'Anton', 'Bebas Neue', sans-serif",
            fontSize: 58,
            letterSpacing: 1.5,
            lineHeight: 1.0,
            color: "#1C1917",
            margin: 0,
            textTransform: "uppercase",
            textAlign: "center",
          }}
        >
          6 POSE & EKSPRESI TAKTIL OP-ZURA
        </h1>
        <p
          style={{
            fontSize: 20,
            color: "#57534E",
            fontWeight: 600,
            margin: 0,
            textAlign: "center",
          }}
        >
          Siap dipasang dinamis di scene video TikTok @zura.ailab manapun via
          React props
        </p>
      </div>

      {/* 2x3 Grid of 6 Tactical Poses */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(3, 1fr)",
          gap: 24,
          width: "100%",
          maxWidth: 980,
          zIndex: 10,
        }}
      >
        {/* POSE 1: IDLE */}
        <div
          style={{
            backgroundColor: "#FAF9F5",
            border: "3.5px solid #1C1917",
            borderRadius: 28,
            padding: "18px 14px 16px",
            boxShadow: "6px 6px 0px #1C1917",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 10,
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 6,
              backgroundColor: "#EFF6FF",
              padding: "4px 12px",
              borderRadius: 999,
              border: "1.5px solid #2563EB",
            }}
          >
            <Sparkles size={14} color="#2563EB" />
            <span
              style={{
                fontFamily: "'Rajdhani', sans-serif",
                fontSize: 15,
                fontWeight: 800,
                color: "#1E40AF",
                letterSpacing: 1,
              }}
            >
              01 · STANDBY / IDLE
            </span>
          </div>

          <TeenageEngineeringBot pose="idle" size={205} />

          <span
            style={{
              fontSize: 14,
              color: "#57534E",
              fontWeight: 700,
              textAlign: "center",
            }}
          >
            Kedip berkala + kuping mengayun
          </span>
        </div>

        {/* POSE 2: TALKING */}
        <div
          style={{
            backgroundColor: "#FAF9F5",
            border: "3.5px solid #1C1917",
            borderRadius: 28,
            padding: "18px 14px 16px",
            boxShadow: "6px 6px 0px #1C1917",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 10,
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 6,
              backgroundColor: "#ECFDF5",
              padding: "4px 12px",
              borderRadius: 999,
              border: "1.5px solid #059669",
            }}
          >
            <Terminal size={14} color="#059669" />
            <span
              style={{
                fontFamily: "'Rajdhani', sans-serif",
                fontSize: 15,
                fontWeight: 800,
                color: "#065F46",
                letterSpacing: 1,
              }}
            >
              02 · TALKING / EQUALIZER
            </span>
          </div>

          <TeenageEngineeringBot pose="talking" size={205} />

          <span
            style={{
              fontSize: 14,
              color: "#57534E",
              fontWeight: 700,
              textAlign: "center",
            }}
          >
            Soundwave LCD reaktif ke VO
          </span>
        </div>

        {/* POSE 3: THINKING */}
        <div
          style={{
            backgroundColor: "#FAF9F5",
            border: "3.5px solid #1C1917",
            borderRadius: 28,
            padding: "18px 14px 16px",
            boxShadow: "6px 6px 0px #1C1917",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 10,
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 6,
              backgroundColor: "#FEF3C7",
              padding: "4px 12px",
              borderRadius: 999,
              border: "1.5px solid #D97706",
            }}
          >
            <HelpCircle size={14} color="#D97706" />
            <span
              style={{
                fontFamily: "'Rajdhani', sans-serif",
                fontSize: 15,
                fontWeight: 800,
                color: "#92400E",
                letterSpacing: 1,
              }}
            >
              03 · THINKING / MIKIR
            </span>
          </div>

          <TeenageEngineeringBot pose="thinking" size={205} />

          <span
            style={{
              fontSize: 14,
              color: "#57534E",
              fontWeight: 700,
              textAlign: "center",
            }}
          >
            Mata miring + garuk bodi
          </span>
        </div>

        {/* POSE 4: POINTING */}
        <div
          style={{
            backgroundColor: "#FAF9F5",
            border: "3.5px solid #1C1917",
            borderRadius: 28,
            padding: "18px 14px 16px",
            boxShadow: "6px 6px 0px #1C1917",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 10,
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 6,
              backgroundColor: "#F3E8FF",
              padding: "4px 12px",
              borderRadius: 999,
              border: "1.5px solid #7E22CE",
            }}
          >
            <MousePointer2 size={14} color="#7E22CE" />
            <span
              style={{
                fontFamily: "'Rajdhani', sans-serif",
                fontSize: 15,
                fontWeight: 800,
                color: "#581C87",
                letterSpacing: 1,
              }}
            >
              04 · POINTING / PRESENTING
            </span>
          </div>

          <TeenageEngineeringBot pose="pointing" size={205} />

          <span
            style={{
              fontSize: 14,
              color: "#57534E",
              fontWeight: 700,
              textAlign: "center",
            }}
          >
            Stylus mekanik nunjuk kartu data
          </span>
        </div>

        {/* POSE 5: TYPING / CODING */}
        <div
          style={{
            backgroundColor: "#FAF9F5",
            border: "3.5px solid #1C1917",
            borderRadius: 28,
            padding: "18px 14px 16px",
            boxShadow: "6px 6px 0px #1C1917",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 10,
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 6,
              backgroundColor: "#E0F2FE",
              padding: "4px 12px",
              borderRadius: 999,
              border: "1.5px solid #0284C7",
            }}
          >
            <Code2 size={14} color="#0284C7" />
            <span
              style={{
                fontFamily: "'Rajdhani', sans-serif",
                fontSize: 15,
                fontWeight: 800,
                color: "#0369A1",
                letterSpacing: 1,
              }}
            >
              05 · CODING / TERMINAL
            </span>
          </div>

          <TeenageEngineeringBot pose="typing" size={205} />

          <span
            style={{
              fontSize: 14,
              color: "#57534E",
              fontWeight: 700,
              textAlign: "center",
            }}
          >
            Tangan ngetik + teks terminal LCD
          </span>
        </div>

        {/* POSE 6: COFFEE / CHILL */}
        <div
          style={{
            backgroundColor: "#FAF9F5",
            border: "3.5px solid #1C1917",
            borderRadius: 28,
            padding: "18px 14px 16px",
            boxShadow: "6px 6px 0px #1C1917",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 10,
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 6,
              backgroundColor: "#FFF7ED",
              padding: "4px 12px",
              borderRadius: 999,
              border: "1.5px solid #EA580C",
            }}
          >
            <Coffee size={14} color="#EA580C" />
            <span
              style={{
                fontFamily: "'Rajdhani', sans-serif",
                fontSize: 15,
                fontWeight: 800,
                color: "#9A3412",
                letterSpacing: 1,
              }}
            >
              06 · SANTAI NGOPI &#123;Z&#125;
            </span>
          </div>

          <TeenageEngineeringBot pose="coffee" size={205} />

          <span
            style={{
              fontSize: 14,
              color: "#57534E",
              fontWeight: 700,
              textAlign: "center",
            }}
          >
            Pegang cangkir keramik &#123;Z&#125; + uap
          </span>
        </div>
      </div>

      {/* Footer Pill */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 14,
          backgroundColor: "#FFFFFF",
          color: "#1C1917",
          padding: "14px 34px",
          borderRadius: 999,
          border: "2.5px solid #1C1917",
          boxShadow: "6px 6px 0px #1C1917",
          zIndex: 10,
        }}
      >
        <span
          style={{
            fontFamily: "'Space Grotesk', monospace",
            fontSize: 18,
            fontWeight: 800,
            color: "#2563EB",
          }}
        >
          TIKTOK @ZURA.AILAB
        </span>
        <span style={{ color: "#D6D3D1" }}>•</span>
        <span
          style={{
            fontFamily: "'Rajdhani', sans-serif",
            fontSize: 18,
            fontWeight: 800,
            letterSpacing: 1.5,
          }}
        >
          RIGGING SISTEM LENGKAP · TINGGAL PANGGIL &lt;TeenageEngineeringBot
          pose="coding" /&gt;
        </span>
      </div>
    </AbsoluteFill>
  );
};
